export default {
  Message: {
    Confirm: '確認',
    Cancel: '關閉'
  },
  DeliveryAddress: {
    Address: '地址'
  },
  Order: {
    OrderNumber: '訂單編號',
    OrderDateTime: '訂單日期&時間 ',
    TotalPrice: '總價',
    OrderStatus: '訂單狀態',
    Paid: '已付款',
    Unpaid: '待付款',
    PayNow: '立即支付'
  },
  RegNPay: {
    BackText: '返回',
    UploadButtonText: '上傳文件(jpg, png, pdf)',
    UploadingText: '正在上傳',
    ConfirmText: '確定',
    UploadSuccessfulText: '上傳成功',
    UploadFailText: '上傳失敗',
    NoFileText: '沒有選中文件',
    UploadLengthText: '最多只能上載{0}檔案',
    UploadSizeText: '最多只能上傳{0}M',
    PleaseSelect: '請選擇',
    SubRecord: '提交紀錄',
    ReferenceNum: '參考編號',
    SubmissionDate: '提交日期',
    Print: '列印',
    PlsPayWay: '請選擇付款方式',
    PreviewTitleText: '請再次確認頁面',
    FormatErrorText: '請輸入正確電郵地址',
    RequiredText: '請檢查你的答案'
  },
  Display: {
    SuccessCase: '成功個案',
    GeneralQuery: '壹般查詢',
    OfficeHours: '辦公時間',
    Hour0: '星期壹至五：',
    Hour1: '早上9時至下午12時,',
    Hour2: '下午1時30分至晚上6時',
    Hour3: '星期六、日及公眾期假休息',
    AddrInfo: '香港九龍彌敦道500號 泰盛（油麻地）商業大廈1302室'
  },
  Action: {
    ViewMore: '查看更多',
    SignUp: '立即報名',
    ReturnHomePage: '返回首頁',
    OrderDetails: '訂單詳情',
    More: '了解更多>>'
  },
  Cms: {
    PlsChoose: '請點擊選擇您想要查看的內容：',
    date: '日期',
    Eventname: '活動名稱',
    Details: '詳情>',
    place: '地點',
    Dateandtime: '日期及時間',
    Inquire: '查詢',
    Informationname: '資訊名稱',
    Updatedate: '更新日期',
    UpdateDateandtime: '更新日期及時間'
  },
  payment: {
    PaymentSuccessTips: '支付結果： 成功',
    PaymentFailTips: '支付結果： 失敗'
  },
  Calendar: {
    KnowMore: '了解更多',
    Time: '時間',
    Venue: '地點',
    NoEvent: '今日暫無活動'
  },
  photo: {
    photo: '相片集',
    BackText: '返回上一級'
  },
  info: {
    Search: '搜尋...',
    Email: '郵箱',
    Tel: '電話/Whatsapp',
    Addr: '新界元朗錦田四排石村(鄰近西鐵錦上路站A出口)'
  },
  Home: {
    Home: '首頁',
    Search: '搜索結果',
    ReadMore: '更多',
    contactmethod: '聯絡方式',
    address: '通訊地址：',
    phone: '電話：',
    fax: '傳真：',
    Email: '電郵：',
    website: '網站：'
  },
  CheckOut: {
    Total: '共',
    Last: '上一頁',
    Next: '下一頁'
  },
  product: {
    per: '第',
    page: '頁'
  }
};
